import { Box, Button, Dialog, IconButton, TextareaAutosize } from "@mui/material";
import { useState } from "react";
import { ChangeEvent } from "react";
import EditIcon from "@mui/icons-material/Edit";
import CloseModalButton from "../../../../components/CloseModalButton";
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from "../../../../components/Dialog.styled";

const NotesModal = ({ notes, setNotes }: { notes?: string; setNotes: (newNotes: string) => void; }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [newNotes, setNewNotes] = useState(notes ?? '');
  
    const onClose = () => setIsOpen(false);
  
    const onChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => setNewNotes(target.value);
  
    const onSave = async () => {
      if (newNotes !== notes) {
        setIsSaving(true);
  
        try {
          await setNotes(newNotes);
        } catch (error) {
          console.error(error);
        }
  
        setIsSaving(false);
      }
  
      onClose();
    };
  
    return (
      <>
        <IconButton aria-label="edit notes" onClick={() => setIsOpen(true)}>
          <EditIcon fontSize="small" sx={{ cursor: 'pointer ' }} />
        </IconButton>
        <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
          <CloseModalButton handleClose={onClose} />
          <StyledDialogTitle>
            <Box className="flex flex-align-center">
              Edit Notes
            </Box>
          </StyledDialogTitle>
          <StyledDialogContent>
            <Box display="flex" flexDirection="column" alignItems="stretch" gap={1}>
              <TextareaAutosize defaultValue={notes} minRows={3} maxRows={20} onChange={onChange} />
            </Box>
          </StyledDialogContent>
          <StyledDialogFooter>
            <Button variant="outlined" size="small" onClick={onClose} disabled={isSaving}>Cancel</Button>
            <Button variant="contained" size="small" aria-label="save notes" onClick={onSave} disabled={isSaving}>{isSaving ? 'Saving...' : 'Save'}</Button>
          </StyledDialogFooter>
        </Dialog>
      </>
    )
  };

  export default NotesModal;